import { __decorate, __awaiter, __param } from 'tslib';
import { Injectable, Optional, SkipSelf, NgModule } from '@angular/core';
import { FormBuilder, Validators, FormControl, FormsModule } from '@angular/forms';
import { Storage, IonicStorageModule } from '@ionic/storage';
import { BaseService, DocumentValidator, ErrorMessageService, UiBsUtilModule } from '@wlp/ui-bs-util';
import { ConfigService, UiPxSignupModule, SpeViewPreAccountProxy } from '@wlp/ui-px-signup';
import { SpeNViewWhiteLabelProxy, SpeNAccountsProxy, SpeViewNAccountProxy, SpeViewNMccProxy, Status, SpeNOnboardingEcProxy, UploadTypeEnum, PositionPhotoEnum, SpeJOnboardingEcUploadProxy, UiPxEcModule, flowProductsAndServices } from '@wlp/ui-px-ec';
export { StatusAnalysisEnum, StatusRequestEnum } from '@wlp/ui-px-ec';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { APP_PARAMETER } from '@wlp/ui-bs-parameter';
import { BehaviorSubject } from 'rxjs';

let ShowcaseService = class ShowcaseService extends BaseService {
    constructor(formBuilder, storage, configService, speNviewWhiteLabel, speNAccountsProxy, speViewNAccountProxy, speViewNMccProxy) {
        super(storage, configService);
        this.formBuilder = formBuilder;
        this.storage = storage;
        this.configService = configService;
        this.speNviewWhiteLabel = speNviewWhiteLabel;
        this.speNAccountsProxy = speNAccountsProxy;
        this.speViewNAccountProxy = speViewNAccountProxy;
        this.speViewNMccProxy = speViewNMccProxy;
    }
    getListProducts(uuidWhiteLabel) {
        return this.speNviewWhiteLabel.getAllProducts(uuidWhiteLabel);
    }
    getAllProductsVisible(uuidWhiteLabel, typeVisible) {
        return this.speNviewWhiteLabel.getAllProductsVisible(uuidWhiteLabel, typeVisible);
    }
    // Request Product
    findUuidAccountPayment(uuidAccountPayment) {
        return this.speViewNAccountProxy.findUuidAccountPayment(uuidAccountPayment);
    }
    saveRequest(preProductWithProductRequest) {
        return this.speNAccountsProxy.save(preProductWithProductRequest);
    }
    updateProductRequest(preProductAccountProduct, idPreProductAccount, uuid) {
        return this.speNAccountsProxy.updateProduct(preProductAccountProduct, idPreProductAccount, uuid);
    }
    // MCC = CNAE
    findActivityBranch() {
        return this.speViewNMccProxy.findActivityBranch();
    }
};
ShowcaseService.ctorParameters = () => [
    { type: FormBuilder },
    { type: Storage },
    { type: ConfigService },
    { type: SpeNViewWhiteLabelProxy },
    { type: SpeNAccountsProxy },
    { type: SpeViewNAccountProxy },
    { type: SpeViewNMccProxy }
];
ShowcaseService = __decorate([
    Injectable()
], ShowcaseService);

let ComercialAgentService = class ComercialAgentService {
    constructor(fb, errorMessageService) {
        this.fb = fb;
        this.errorMessageService = errorMessageService;
    }
    getFormComercialAgent() {
        this.formComercialAgent = this.fb.group({
            nameAgent: ['', [Validators.minLength(6), Validators.maxLength(100)]],
            cpfAgent: ['', [DocumentValidator.isValidCPF]],
        });
        return this.formComercialAgent;
    }
    getMessageError() {
        return {
            nameAgent: [
                { type: 'minlength', message: 'ONBORDING.COMERCIAL_AGENT.FORM.NAME_AGENT.MESSAGE.MIN_LENGTH' },
                { type: 'maxlength', message: 'ONBORDING.COMERCIAL_AGENT.FORM.NAME_AGENT.MESSAGE.MAX_LENGTH' },
            ],
            cpfAgent: [
                { type: 'cpfNotValid', message: 'ONBORDING.COMERCIAL_AGENT.FORM.CPF_AGENT.MESSAGE.CPF_NOT_VALID' }
            ]
        };
    }
    getErrorComercialAgentData(error) {
        this.errorMessageService.getError(error);
    }
    //TODO: Adicionar retorno Observable<any>
    sendComercialAgentData(form) {
        const comercialAgentData = this.prepareComercialAgentData(form);
        // return this.speNOpenAccountProxy.updateComercialAgent(this.keyPreAccount, comercialAgentData);
    }
    syncForm(data) {
        const info = {
            nameAgent: data.nameAgent,
            cpfAgent: data.documentAgent,
        };
        this.formComercialAgent.patchValue(info);
    }
    getPreAccount(uuid) {
        // this.keyPreAccount = uuid;
        // this.speViewPreAccountProxy
        //   .findComercialAgent(uuid)
        //   .pipe(
        //   tap(data => {
        //     !!data.comercialAgentData ? this.syncForm(data.comercialAgentData) : null
        //   }),
        //   catchError(error => {
        //     this.errorMessageService.getError(error)
        //     return of(null);
        //   })
        // ).subscribe();
    }
    updateForm() {
        return __awaiter(this, void 0, void 0, function* () {
            // await this.loadKey();
            // if (this.keyPreAccount !== null) {
            //   this.getPreAccount(this.keyPreAccount);
            // }
        });
    }
    prepareComercialAgentData(form) {
        const data = form.getRawValue();
        const comercialAgentDataResponse = {
            nameAgent: data.nameAgent,
            cpfAgent: data.cpfAgent
        };
        const preAccountResponse = {
            // _id: this.keyPreAccount,
            comercialAgentData: comercialAgentDataResponse
        };
        return preAccountResponse;
    }
};
ComercialAgentService.ctorParameters = () => [
    { type: FormBuilder },
    { type: ErrorMessageService }
];
ComercialAgentService = __decorate([
    Injectable()
], ComercialAgentService);

let ContractEcService = class ContractEcService {
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
    }
    getContractForm() {
        this.contractEcForm = this.formBuilder.group({
            acceptContract: false
        });
        return this.contractEcForm;
    }
    //TODO: Adicionar retorno Observable<any>
    sendContract(form) {
        const contractData = this.prepareContract(form);
        //return this.proxy.updatedContract(this.keyPreAccount, contractData);
    }
    prepareContract(form) {
        const data = form.getRawValue();
        const contractRequest = {
            acceptContract: data.acceptContract,
            dataAccept: data.dataAccept
        };
        const preAccountRequest = {
            // _id: this.keyPreAccount,
            contract: contractRequest,
            status: Status.IN_ANALYSIS_COMPLIANCE,
        };
        return preAccountRequest;
    }
};
ContractEcService.ctorParameters = () => [
    { type: FormBuilder }
];
ContractEcService = __decorate([
    Injectable()
], ContractEcService);

class ExtractDigitalReceiptResponse {
}

let ExtractDigitalReceiptService = class ExtractDigitalReceiptService {
    constructor() { }
    getStatement(uuidWhiteLabel, dateInitial, dateEnd) {
        const data = [
            {
                uuid: "",
                transactionId: "",
                category: "Serviços",
                description: "Lorem Ipsum is simply Lorem Ipsum is simply",
                icon: "grid-outline",
                typeStatement: "",
                balance: 120,
                credit: 0,
                debit: 0,
                dateRegister: "2020-06-02T16:29:26.809Z",
            },
            {
                uuid: "",
                transactionId: "",
                category: "Serviços",
                description: "Lorem Ipsum is simply Lorem Ipsum is simply",
                icon: "grid-outline",
                typeStatement: "",
                balance: 120,
                credit: 0,
                debit: 0,
                dateRegister: "2020-06-02T16:29:26.809Z",
            },
            {
                uuid: "",
                transactionId: "",
                category: "Serviços",
                description: "Lorem Ipsum is simply Lorem Ipsum is simply",
                icon: "grid-outline",
                typeStatement: "",
                balance: 120,
                credit: 0,
                debit: 0,
                dateRegister: "2020-06-02T16:29:26.809Z",
            },
            {
                uuid: "",
                transactionId: "",
                category: "Serviços",
                description: "Lorem Ipsum is simply Lorem Ipsum is simply",
                icon: "grid-outline",
                typeStatement: "",
                balance: 120,
                credit: 0,
                debit: 0,
                dateRegister: "2020-06-02T16:29:26.809Z",
            },
            {
                uuid: "",
                transactionId: "",
                category: "Serviços",
                description: "Lorem Ipsum is simply Lorem Ipsum is simply",
                icon: "grid-outline",
                typeStatement: "",
                balance: 120,
                credit: 0,
                debit: 0,
                dateRegister: "2020-06-02T16:29:26.809Z",
            },
            {
                uuid: "",
                transactionId: "",
                category: "Serviços",
                description: "Lorem Ipsum is simply Lorem Ipsum is simply",
                icon: "grid-outline",
                typeStatement: "",
                balance: 120,
                credit: 0,
                debit: 0,
                dateRegister: "2020-06-02T16:29:26.809Z",
            },
            {
                uuid: "",
                transactionId: "",
                category: "Serviços",
                description: "Lorem Ipsum is simply Lorem Ipsum is simply",
                icon: "grid-outline",
                typeStatement: "",
                balance: 0,
                credit: 40,
                debit: 0,
                dateRegister: "2020-06-02T16:29:26.809Z",
            },
            {
                uuid: "",
                transactionId: "",
                category: "Serviços",
                description: "Lorem Ipsum is simply Lorem Ipsum is simply",
                icon: "grid-outline",
                typeStatement: "",
                balance: 0,
                credit: 0,
                debit: -10,
                dateRegister: "2020-06-02T16:29:26.809Z",
            },
            {
                uuid: "",
                transactionId: "",
                category: "Serviços",
                description: "Lorem Ipsum is simply Lorem Ipsum is simply",
                icon: "grid-outline",
                typeStatement: "",
                balance: 0,
                credit: 1000,
                debit: 0,
                dateRegister: "2020-06-02T16:29:26.809Z",
            },
        ];
        return data;
    }
    getErroMessage(err) {
        /*  return this.errorMessageService.getError(err); */
    }
    valueDisplayCreditOrDebit(extractDigitalAccount) {
        return !!extractDigitalAccount.credit ? extractDigitalAccount.credit : extractDigitalAccount.debit;
    }
    showIsBalance(typeStatement) {
        return Number(typeStatement) === 0;
    }
    showIsCreditOrDebit(typeStatement) {
        return Number(typeStatement) > 0;
    }
    isCredit(typeStatement) {
        return Number(typeStatement) === 1;
    }
    prepareExtract(listDataStatement) {
        let listExtract = [];
        listDataStatement
            .forEach(data => listExtract.push(this.mountExtractDigital(data)));
        return listExtract;
    }
    mountExtractDigital(dataStatementResponse) {
        const extractDigitalAccount = new ExtractDigitalReceiptResponse();
        extractDigitalAccount.uuid = dataStatementResponse.uuid;
        extractDigitalAccount.transactionId = dataStatementResponse.transactionId;
        extractDigitalAccount.category = 'Outros';
        extractDigitalAccount.description = dataStatementResponse.description;
        extractDigitalAccount.icon = 'grid-outline';
        extractDigitalAccount.typeStatement = dataStatementResponse.typeStatement;
        extractDigitalAccount.balance = dataStatementResponse.balance;
        extractDigitalAccount.credit = dataStatementResponse.credit;
        extractDigitalAccount.debit = dataStatementResponse.debit;
        extractDigitalAccount.dateRegister = dataStatementResponse.dateRegister;
        return extractDigitalAccount;
    }
};
ExtractDigitalReceiptService = __decorate([
    Injectable()
], ExtractDigitalReceiptService);

let FaqService = class FaqService {
    constructor(speNOnboardingEcProxy, errorMessageService) {
        this.speNOnboardingEcProxy = speNOnboardingEcProxy;
        this.errorMessageService = errorMessageService;
    }
    getFaq() {
        /*     this.speNOnboardingEcProxy
              .getFaqList(uuidAccount)
              .subscribe(
                data => {
                  console.log(data);
                },
                err => this.errorMessageService.getError(err)) */
        return this.speNOnboardingEcProxy.getFaqList();
    }
};
FaqService.ctorParameters = () => [
    { type: SpeNOnboardingEcProxy },
    { type: ErrorMessageService }
];
FaqService = __decorate([
    Injectable()
], FaqService);

class UploadResponse {
}

let UploadEcService = class UploadEcService {
    constructor(speJOnboardingEcUploadProxy, errorMessageService) {
        this.speJOnboardingEcUploadProxy = speJOnboardingEcUploadProxy;
        this.errorMessageService = errorMessageService;
    }
    getPartnerDocuments(uuidPartner) {
        /*     this.speJOnboardingEcUploadProxy
              .getUploads(uuidAccount)
              .subscribe(
                data => {
                  console.log(data);
                },
                err => this.errorMessageService.getError(err)) */
        return this.speJOnboardingEcUploadProxy.getUploads('uuidAccount', uuidPartner);
    }
    itsloaded(uuidPartner, document) {
        let documentList = this.getPartnerDocuments(uuidPartner);
        return documentList[document];
    }
    uploadFile(uuidAccount, file) {
        const uploadFile = this.prepareUpload(file);
        return this.speJOnboardingEcUploadProxy
            .uploadFile(uuidAccount, uploadFile);
    }
    prepareUpload(file) {
        const uploadResponse = new UploadResponse();
        uploadResponse.fileBase64 = file.fileBase64;
        uploadResponse.uploadType = UploadTypeEnum[file.uploadType];
        uploadResponse.positionPhoto = PositionPhotoEnum[file.positionPhoto];
        uploadResponse.fileName = file.title;
        return uploadResponse;
    }
    getErroUpload(err) {
        this.errorMessageService.getError(err);
    }
};
UploadEcService.ctorParameters = () => [
    { type: SpeJOnboardingEcUploadProxy },
    { type: ErrorMessageService }
];
UploadEcService = __decorate([
    Injectable()
], UploadEcService);

let PartnersEcService = class PartnersEcService extends BaseService {
    constructor(formBuilder, storage, configService, errorMessageService, speNOnboardingEc) {
        super(storage, configService);
        this.formBuilder = formBuilder;
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.speNOnboardingEc = speNOnboardingEc;
        this.errorMessages = {
            fullname: [
                { type: 'required', message: 'ONBOARDING_EC.PARTNERS_EC.FORM.FULLNAME.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBOARDING_EC.PARTNERS_EC.FORM.FULLNAME.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 }
                },
                {
                    type: 'maxlength',
                    message: 'ONBOARDING_EC.PARTNERS_EC.FORM.FULLNAME.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 100 }
                },
            ],
            docNumber: [
                { type: 'required', message: 'ONBOARDING_EC.PARTNERS_EC.FORM.CPF.MESSAGE.REQUIRED' },
                { type: 'cpfNotValid', message: 'ONBOARDING_EC.PARTNERS_EC.FORM.CPF.MESSAGE.CPF_NOT_VALID' }
            ]
        };
        this.businessPartnerList = [];
        this.behaviorList = new BehaviorSubject([]);
    }
    getErrorBusinessPartner(error) {
        this.errorMessageService.getError(error);
    }
    getNewUuid() {
        return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
    }
    getPartnersList(uuidAccount, uuidWhiteLabel) {
        return this.speNOnboardingEc.getListPartners(uuidAccount, uuidWhiteLabel);
    }
    addNewPartner(form, uuidAccount, uuidWhiteLabel) {
        const partnerItem = form.getRawValue();
        const newPartner = Object.assign({}, partnerItem, { uuidBusinessPartner: this.getNewUuid(), master: false });
        return this.speNOnboardingEc.addNewPartner(uuidAccount, uuidWhiteLabel, newPartner);
    }
    editPartner(form, uuidAccount, uuidWhiteLabel, uuidBusinessPartner) {
        const partnerItem = form.getRawValue();
        const editedPartner = Object.assign({ uuidBusinessPartner }, partnerItem);
        return this.speNOnboardingEc.editPartner(uuidAccount, uuidWhiteLabel, uuidBusinessPartner, editedPartner);
    }
    removePartner(uuidAccount, uuidWhiteLabel, uuidBusinessPartner) {
        return this.speNOnboardingEc.removePartner(uuidAccount, uuidWhiteLabel, uuidBusinessPartner);
    }
    editForm(businessPartner) {
        this.formBusinessPartner.patchValue(Object.assign({}, businessPartner));
        return this.formBusinessPartner;
    }
    getFormBusinessPartner() {
        this.formBusinessPartner = this.formBuilder.group({
            fullname: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(100)
            ])),
            docNumber: new FormControl('', Validators.compose([
                Validators.required,
                DocumentValidator.isValidCPF
            ])),
            legalRepresentative: false,
            attorney: false,
            partner: false,
            master: false
        });
        return this.formBusinessPartner;
    }
    getFormMessageError() {
        return this.errorMessages;
    }
};
PartnersEcService.ctorParameters = () => [
    { type: FormBuilder },
    { type: Storage },
    { type: ConfigService },
    { type: ErrorMessageService },
    { type: SpeNOnboardingEcProxy }
];
PartnersEcService = __decorate([
    Injectable()
], PartnersEcService);

var UiBsEcModule_1;
let UiBsEcModule = UiBsEcModule_1 = class UiBsEcModule {
    constructor(parentModule) {
        //...
    }
    static forRoot(config) {
        return {
            ngModule: UiBsEcModule_1,
            providers: [
                { provide: APP_PARAMETER, useValue: config }
            ]
        };
    }
};
UiBsEcModule.ctorParameters = () => [
    { type: UiBsEcModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
];
UiBsEcModule = UiBsEcModule_1 = __decorate([
    NgModule({
        declarations: [],
        imports: [
            CommonModule,
            FormsModule,
            IonicModule,
            IonicStorageModule.forRoot({ driverOrder: ['indexeddb', 'sqlite', 'websql'] }),
            UiPxEcModule,
            UiBsUtilModule,
            RxReactiveFormsModule,
            UiPxSignupModule
        ],
        providers: [
            FaqService,
            UploadEcService,
            ExtractDigitalReceiptService,
            ContractEcService,
            ComercialAgentService,
            ExtractDigitalReceiptService,
            PartnersEcService,
            ShowcaseService
        ]
    }),
    __param(0, Optional()), __param(0, SkipSelf())
], UiBsEcModule);

let ProductsService = class ProductsService {
    constructor() { }
    getProducts() {
        const data = [
            {
                id: 1,
                title: "Maquininha",
                date: "2020-06-02T16:29:26.809Z",
                description: "Lorem Ipsum is simply Lorem Ipsum is simply",
                typeProductsAndServices: flowProductsAndServices.CARD_MACHINE,
            },
            {
                id: 2,
                title: "Cartão de Credito",
                date: "2020-06-02T16:29:26.809Z",
                description: "Lorem Ipsum is simply Lorem Ipsum is simply",
                typeProductsAndServices: flowProductsAndServices.CREDIT_CARD,
            },
            {
                id: 3,
                title: "Boleto",
                date: "2020-06-02T16:29:26.809Z",
                description: "Lorem Ipsum is simply Lorem Ipsum is simply",
                typeProductsAndServices: flowProductsAndServices.BILLET,
            },
            {
                id: 4,
                title: "Energia",
                date: "2020-06-02T16:29:26.809Z",
                description: "Lorem Ipsum is simply Lorem Ipsum is simply",
                typeProductsAndServices: flowProductsAndServices.ENERGY,
            },
        ];
        return data;
    }
};
ProductsService = __decorate([
    Injectable()
], ProductsService);

let StatusAccountECService = class StatusAccountECService extends BaseService {
    constructor(speViewPreAccountProxy, storage, configService) {
        super(storage, configService);
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.storage = storage;
        this.configService = configService;
    }
    loadStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            /* await this.loadKey();
            return this.speViewPreAccountProxy.findStatusById(this.keyPreAccount).toPromise(); */
            return Status;
        });
    }
    getTitle(status) {
        if (status === Status.IN_ANALYSIS_COMPLIANCE ||
            status === Status.APPROVED_COMPLIANCE ||
            status === Status.IN_ANALYSIS_TOPAZIO ||
            status === Status.APPROVED_TOPAZIO) {
            return 'ONBORDING.STATUS_ACCOUNT.IN_ANALYSIS.DESCRIPTION_TITLE';
        }
        else if (status === Status.DOCUMENT_LEGAL_PERSON_REPROVED ||
            status === Status.DOCUMENT_PHYSICAL_PERSON_REPROVED) {
            return 'ONBORDING.STATUS_ACCOUNT.DOCUMENT_INVALID.DESCRIPTION_TITLE';
        }
        else if (status === Status.REGISTRATION_DATA_LEGAL_PERSON_INVALID ||
            status === Status.REGISTRATION_DATA_PHYSICAL_PERSON_INVALID) {
            return 'ONBORDING.STATUS_ACCOUNT.DATA_INVALID.DESCRIPTION_TITLE';
        }
        else if (status === Status.REPROVED) {
            return 'ONBORDING.STATUS_ACCOUNT.REPROVED.DESCRIPTION_TITLE';
        }
        else if (status === Status.FINISHED) {
            return 'ONBORDING.STATUS_ACCOUNT.APPROVED.DESCRIPTION_TITLE';
        }
    }
    getDescription(status) {
        if (status === Status.IN_ANALYSIS_COMPLIANCE ||
            status === Status.APPROVED_COMPLIANCE ||
            status === Status.IN_ANALYSIS_TOPAZIO ||
            status === Status.APPROVED_TOPAZIO) {
            return 'ONBORDING.STATUS_ACCOUNT.IN_ANALYSIS.DESCRIPTION';
        }
        else if (status === Status.DOCUMENT_LEGAL_PERSON_REPROVED ||
            status === Status.DOCUMENT_PHYSICAL_PERSON_REPROVED) {
            return 'ONBORDING.STATUS_ACCOUNT.DOCUMENT_INVALID.DESCRIPTION';
        }
        else if (status === Status.REGISTRATION_DATA_LEGAL_PERSON_INVALID ||
            status === Status.REGISTRATION_DATA_PHYSICAL_PERSON_INVALID) {
            return 'ONBORDING.STATUS_ACCOUNT.DATA_INVALID.DESCRIPTION';
        }
        else if (status === Status.REPROVED) {
            return 'ONBORDING.STATUS_ACCOUNT.REPROVED.DESCRIPTION';
        }
        else if (status === Status.FINISHED) {
            return 'ONBORDING.STATUS_ACCOUNT.APPROVED.DESCRIPTION';
        }
    }
    getTextButton(status) {
        if (status === Status.IN_ANALYSIS_COMPLIANCE ||
            status === Status.APPROVED_COMPLIANCE ||
            status === Status.IN_ANALYSIS_TOPAZIO ||
            status === Status.APPROVED_TOPAZIO) {
            return 'ONBORDING.STATUS_ACCOUNT.IN_ANALYSIS.BUTTON';
        }
        else if (status === Status.DOCUMENT_LEGAL_PERSON_REPROVED ||
            status === Status.DOCUMENT_PHYSICAL_PERSON_REPROVED) {
            return 'ONBORDING.STATUS_ACCOUNT.DOCUMENT_INVALID.BUTTON';
        }
        else if (status === Status.REGISTRATION_DATA_LEGAL_PERSON_INVALID ||
            status === Status.REGISTRATION_DATA_PHYSICAL_PERSON_INVALID) {
            return 'ONBORDING.STATUS_ACCOUNT.DATA_INVALID.BUTTON';
        }
        else if (status === Status.REPROVED) {
            return 'ONBORDING.STATUS_ACCOUNT.REPROVED.BUTTON';
        }
        else if (status === Status.FINISHED) {
            return 'ONBORDING.STATUS_ACCOUNT.APPROVED.BUTTON';
        }
    }
};
StatusAccountECService.ctorParameters = () => [
    { type: SpeViewPreAccountProxy },
    { type: Storage },
    { type: ConfigService }
];
StatusAccountECService = __decorate([
    Injectable()
], StatusAccountECService);

class FaqResponse {
}

class ContractEcResponse {
}

class productsAndServicesResponse {
}

class ComercialAgentResponse {
}

class BusinessPartnerResponse {
}

/*
 * Public API Surface of ui-bs-ec
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BusinessPartnerResponse, ComercialAgentResponse, ComercialAgentService, ContractEcResponse, ContractEcService, ExtractDigitalReceiptResponse, ExtractDigitalReceiptService, FaqResponse, FaqService, PartnersEcService, ProductsService, ShowcaseService, StatusAccountECService, UiBsEcModule, UploadEcService, productsAndServicesResponse };
//# sourceMappingURL=wlp-ui-bs-ec.js.map
